// extracted by mini-css-extract-plugin
export default {"container":"FlowContainer-module__container--uTy0p"};